export default {
    mounted(el, binding) {
        // 获取指令参数，默认为 'absolute'
        const position = binding.arg || 'absolute';
        el.style.position = position;
        el.style.cursor = 'move';

        const startDragging = (e) => {
            el._dragging = true;
            el._startX = e.clientX;
            el._startY = e.clientY;
            // 使用 getComputedStyle 获取最新的 left 和 top 解决vw、vh单位导致的拖动不准确问题
            const computedStyle = getComputedStyle(el);
            el._offsetX = parseInt(computedStyle.left, 10);
            el._offsetY = parseInt(computedStyle.top, 10);
            
            // 如果是absolute定位，需要记录滚动位置来处理滚动偏移
            if (position === 'absolute') {
                el._startScrollX = window.pageXOffset || document.documentElement.scrollLeft;
                el._startScrollY = window.pageYOffset || document.documentElement.scrollTop;
            }
            
            document.addEventListener('mousemove', drag);
            document.addEventListener('mouseup', stopDragging);
        };

        const drag = (e) => {
            if (!el._dragging) return;
            
            let newLeft, newTop;
            
            if (position === 'absolute') {
                // absolute定位需要考虑滚动偏移
                const currentScrollX = window.pageXOffset || document.documentElement.scrollLeft;
                const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
                const scrollDeltaX = currentScrollX - el._startScrollX;
                const scrollDeltaY = currentScrollY - el._startScrollY;
                
                newLeft = el._offsetX + e.clientX - el._startX + scrollDeltaX;
                newTop = el._offsetY + e.clientY - el._startY + scrollDeltaY;
            } else {
                // fixed定位不需要考虑滚动偏移
                newLeft = el._offsetX + e.clientX - el._startX;
                newTop = el._offsetY + e.clientY - el._startY;
            }
            
            el.style.left = `${newLeft}px`;
            el.style.top = `${newTop}px`;
            el.style.right = 'unset';
            el.style.bottom = 'unset';
        };

        const stopDragging = () => {
            el._dragging = false;
            document.removeEventListener('mousemove', drag);
            document.removeEventListener('mouseup', stopDragging);
        };

        el.addEventListener('mousedown', startDragging);
    },
    unmounted(el) {
        el.removeEventListener('mousedown', el._startDragging);
        document.removeEventListener('mousemove', el._drag);
        document.removeEventListener('mouseup', el._stopDragging);
    },
};